import useAlias from '@alias';
import Input from '@components/_elements/Input/Input';
import { SavedSearch } from '@types';
import { ReactElement } from 'react';
import { AGREG_TYPES } from './historianUtils';

interface AggregationInputProps {
  setSearchField: <T>(field: string, value: T) => void;
  activeSearch: SavedSearch;
}

export function AggregationInput({
  activeSearch,
  setSearchField,
}: AggregationInputProps): ReactElement {
  const alias = useAlias();
  return (
    <Input
      type='multiselect-dropdown'
      placeholder={alias('Interval')}
      value={activeSearch.aggregationFunctions}
      className='width-s'
      styleDD={{ width: '163px' }}
      onChange={(val: string[]): void =>
        setSearchField('aggregationFunctions', val)
      }
      options={AGREG_TYPES}
    />
  );
}
